<template>
  <div class="hello">
    <div class="card"></div>
    <div class="vidioList">
      <!-- <el-button class="show" type="primary" @click="vidioShow">{{ isShow?'收起':'展开' }}</el-button> -->
      <div class="vidio" v-for="(item, index) in vidioList" :key="index">
        <el-button type="text" @click="vidioBtn(item)">{{
          item.name
        }}</el-button>
      </div>
    </div>
    <!-- <div class="vidioBox">
      <el-collapse-transition>
        <div class="vidioDiv" v-show="isShow">
          <iframe :src="vidioSrc" width="100%" height="100%" frameborder="0" scrolling="no"></iframe>
        </div>
      </el-collapse-transition>
    </div> -->

    <div class="urlDiv">
      <el-input
        placeholder="请输入URL"
        v-model="url"
        @keyup.enter.native="search"
        class="input-with-select"
      >
        <el-select @change="search"
          class="website"
          v-model="website"
          slot="prepend"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in websiteList"
            :key="item.value"
            :label="item.name + '' + index"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          @click="search"
          slot="append"
        >解析</el-button>
      </el-input>
    </div>
    <div style="overflow: hidden">
      <div class="iframeDiv">
        <iframe
          class="iframe"
          :src="iframeSrc"
          @load="srcChange"
          width="100%"
          height="100%"
          frameborder="0"
          allowfullscreen
          scrolling="no"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      url: '',
      website: 'https://jx.777jiexi.com/player/?url=',
      websiteList: [
        // { value: 'https://im1907.top/?jx=', name: '线路二' },
        { value: 'https://jx.777jiexi.com/player/?url=', name: '线路' },
        { value: 'https://jx.bozrc.com:4433/player/?url=', name: '线路' },
        { value: 'https://z1.m1907.top/?jx=', name: '线路' },
        { value: 'https://jx.aidouer.net/?url=', name: '线路' },
        { value: 'https://vip.bljiex.com/?v=', name: '线路' },
        { value: 'https://api.qianqi.net/vip/?url=', name: '线路' },
        { value: 'https://jx.618g.com/?url=', name: '线路' },
        { value: 'https://www.ckplayer.vip/jiexi/?url=', name: '线路' },
        { value: 'https://www.gai4.com/?url=', name: '线路' },
        { value: 'https://www.ckmov.vip/api.php?url=', name: '线路' },
        { value: 'https://www.h8jx.com/jiexi.php?url=', name: '线路' },
        { value: 'https://jx.playerjy.com/?url=', name: '线路' },
        { value: 'https://ckmov.ccyjjd.com/ckmov/?url=', name: '线路' },
        { value: 'https://api.jiexi.la/?url=', name: '线路' },
        { value: 'https://vip.laobandq.com/jiexi.php?url=', name: '线路' },
        {
          value: 'https://api.leduotv.com/wp-api/ifr.php?isDp=1&amp;vid=',
          name: '线路',
        },
        { value: 'https://www.mtosz.com/m3u8.php?url=', name: '线路' },
        { value: 'https://jx.m3u8.tv/jiexi/?url=', name: '线路' },
        { value: 'https://www.nxflv.com/?url=', name: '线路' },
        { value: 'https://okjx.cc/?url=', name: '线路' },
        { value: 'https://www.playm3u8.cn/jiexi.php?url=', name: '线路' },
        { value: 'https://www.pangujiexi.cc/jiexi.php?url=', name: '线路' },
        { value: 'https://jx.blbo.cc:4433/?url=', name: '线路' },
        { value: 'https://jx.mmkv.cn/tv.php?url=', name: '线路' },
        { value: 'https://jx.rdhk.net/?v=', name: '线路' },
        { value: 'https://jx.blbo.cc:4433/?url=', name: '线路' },
        { value: 'https://jx.ap2p.cn/?url=', name: '线路' },
        { value: 'https://jsap.attakids.com/?url=', name: '线路' },
        { value: 'https://jx.dj6u.com/?url=', name: '线路' },
        { value: 'https://jx.ivito.cn/?url=', name: '线路' },
        { value: 'https://jx.xmflv.com/?url=', name: '线路' },
        { value: 'https://sb.5gseo.net/?url=', name: '线路' },
        { value: 'https://jx.yparse.com/index.php?url=', name: '线路' },
        { value: 'https://go.yh0523.cn/y.cy?url=', name: '线路' },
        { value: 'https://www.1717yun.com/jx/ty.php?url=', name: '线路' },
        { value: 'https://jx.000180.top/jx/?url=', name: '线路' },
        { value: 'https://jx.4kdv.com/?url=', name: '线路' },
        { value: 'https://www.8090g.cn/?url=', name: '线路' },
      ],
      vidioList: [
        { value: 'https://www.youku.com/', name: '优酷' },
        { value: 'https://www.iqiyi.com/', name: '爱奇艺' },
        { value: 'https://v.qq.com/', name: '腾讯视频' },
        { value: 'https://www.bilibili.com/', name: '哔哩哔哩' },
        { value: 'https://www.mgtv.com/', name: '芒果TV' },
        { value: 'https://www.ixigua.com/', name: '西瓜视频' },
      ],
      iframeSrc: '',
      vidioSrc: '',
      isShow: true,
    }
  },
  destroyed() {},
  methods: {
    search() {
      this.iframeSrc = this.website + this.url
    },
    vidioBtn(item) {
      // this.vidioSrc = item.value
      window.open(item.value, '_blank')
    },
    vidioShow() {
      this.isShow = !this.isShow
    },
    srcChange(e) {
      console.log(e)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.show {
  margin-right: 10px;
}
.vidioDiv {
  height: 800px;
  width: 100%;
  border: 1px solid #dcdfe6;
  margin-bottom: 10px;
}
.urlDiv {
  margin-bottom: 10px;
}
.website {
  width: 150px;
}
.iframeDiv {
  position: relative;
  height: 800px;
  width: 100%;
  border: 1px solid #dcdfe6;
  background-image: linear-gradient(135deg, #81ffef 10%, #f067b4 100%);
  color: rgba(255, 255, 255, 0.8);
  font-family: sans-serif;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  border-left: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 10px -10px 20px rgba(0, 0, 0, 0.2),
    -10px 10px 20px rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(6px); /*  元素后面区域添加模糊效果 */
}
.iframe{
  position: relative;
  z-index: 99;
}
.iframeDiv::after{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  content: 'video';
  color: #fff;
  font-size: 200px;
  font-weight: 700;
  z-index: 1;
}

.vidioList {
  display: flex;
}
.vidio {
  margin-right: 10px;
}
.vidio:nth-last-child(1) {
  margin-right: 0;
}
</style>
